/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * ヘリの要請時期
 */
export type BaseInfoDrHeliRequestedTimingEnum =
  (typeof BaseInfoDrHeliRequestedTimingEnum)[keyof typeof BaseInfoDrHeliRequestedTimingEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseInfoDrHeliRequestedTimingEnum = {
  ON_SITE_REQUEST: 'ON_SITE_REQUEST',
  INITIAL_REQUEST: 'INITIAL_REQUEST',
} as const;
